module.exports = __webpack_public_path__ + "media/goforajourney/img/barcelona/img313-382655984eaf5e6edf5231b8e8f9f827.jpg";